module.exports = __webpack_public_path__ + "img/refresh3.f720b34b.svg";